
// region JS Imports

// region External Modules
import $ from "jquery"

import { EventEmitter } from "events"
// endregion External Modules

// region Private Modules
// endregion Private Modules

// region Public Components
import {
  Factory as PhaseBuildingSelectorFactory,
  PhaseBuildingSelector,
} from "./phase_building_selector/index"
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


interface Selector {
  scope: string

  phase_building_select: string

  table:      string
  table_row:  string
}
interface InputSelector {
  scope?: string | JQuery

  phase_building_select?: string | JQuery

  table?:                          string | JQuery
  table_row?:                      string | JQuery
}
const default_selector = {
  scope: ".page-section--children-buildings-section--desktop-ver",

  phase_building_select: ".page-section--children-buildings-section--table--phase-building-select-container",

  table:      ".page-section--children-buildings-section--table",
  table_row:  ".page-section--children-buildings-section--table-row",
}

class ChildrenBuildingsSection extends EventEmitter {
  protected selector: Selector

  protected $scope: JQuery

  protected $phase_building_select: JQuery

  protected $table:      JQuery
  protected $table_row:  JQuery

  protected phase_building_select?: PhaseBuildingSelector


  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, default_selector, selector)
    this.$scope = $(this.selector.scope)

    this.$phase_building_select = this.$scope.find(this.selector.phase_building_select)

    this.$table = this.$scope.find(this.selector.table)
    this.$table_row = this.$scope.find(this.selector.table_row)

    if ( this.$phase_building_select.length > 0 ) {
      this.phase_building_select = PhaseBuildingSelectorFactory.instance()
    }

    this.created()
    this.bind_action()
  }

  protected created() {
    this.on_phase_building_select(this.phase_building_select?.selected_option() as string)
  }

  protected bind_action() {
    this.phase_building_select?.on("val_change", () => {
      const target_building_option = this.phase_building_select?.selected_option() as string

      this.on_phase_building_select(target_building_option)
    })
  }

  protected on_phase_building_select(target_building_option: string | null) {
    this.$table_row.hide()
    let $filteredBuildings: JQuery<HTMLElement>

    if (target_building_option) {
      $filteredBuildings = this.$table_row.filter(`[parent_id="${target_building_option}"]`)

      if ($filteredBuildings.length === 0) {
        $filteredBuildings = this.$table_row.filter(`[building_id="${target_building_option}"]`)
      }
    } else {

      $filteredBuildings = this.$table_row
    }
    $filteredBuildings.show()
  }

}

const Factory = {
  _instance: null as null | ChildrenBuildingsSection,
  instance(){
    if (this._instance != null){
      return this._instance
    }
    this._instance = this.create()
    return this._instance
  },
  create(){
    return new ChildrenBuildingsSection()
  },
}

export {
  Factory,
}
